import React from 'react';
import { ModalWindow } from 'ui-toolkit';
import type { FCWithChildren } from '../../../types/FCWithChildren';

export interface IMatchingModalProps {
  intro: string;
  onClose: () => void;
}

export const MatchingModal: FCWithChildren<IMatchingModalProps> = ({ children, intro, onClose }) => {
  return (
    <ModalWindow
      onClose={onClose}
      width={`90vw`}
      title={<div className={'text-lg font-semibold'}>Search for Expected Deposits or Order File Numbers</div>}
      header={<div className={'text-sm font-normal'}>{intro}</div>}
    >
      {children}
    </ModalWindow>
  );
};
